// @ts-strict-ignore
import {Pipe, PipeTransform} from "@angular/core";
import {SimTrainingRoomService} from "@services";
import {from, Observable} from "rxjs";
import {TrainingRoom} from "@models";

@Pipe({
	name: "getTrainingRoomById",
	standalone: true,
})
export class GetTrainingRoomByIdPipe implements PipeTransform {
	constructor(private _simTrainingRoomService: SimTrainingRoomService) {}

	transform(value: string, ...args: unknown[]): Observable<TrainingRoom> {
		if (value) {
			return from(this._simTrainingRoomService.getTrainingRoomById(value));
		}
		return null;
	}
}
